export default __webpack_public_path__ + "static/marketing_1-3672aafb197807fbf7200ecd465919c7.webp";